<template>
  <div class="batch-question-dialog">
    <el-dialog
      title="批量录入题目"
      :visible.sync="dialogVisible"
      width="1200px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      :show-close="false"
      custom-class="batch-question-dialog-centered"
      @close="handleDialogClose">
      
      <!-- 添加自定义的关闭按钮，替代对话框默认的右上角X按钮 -->
      <div style="position: absolute; top: 20px; right: 20px; cursor: pointer; z-index: 2000;" @click="handleCloseButtonClick">
        <i class="el-icon-close" style="font-size: 20px;"></i>
      </div>
      
      <!-- 确认关闭的内部对话框 -->
      <div v-if="showConfirmation" class="confirmation-overlay">
        <div class="confirmation-dialog">
          <div class="confirmation-content">
            <i class="el-icon-warning" style="color: #E6A23C; font-size: 24px; margin-right: 10px;"></i>
            <span>有未保存的题目数据，确认要关闭吗？</span>
          </div>
          <div class="confirmation-buttons">
            <el-button size="small" @click="cancelClose">取 消</el-button>
            <el-button size="small" type="primary" @click="confirmClose">确 定</el-button>
          </div>
        </div>
      </div>
      
      <!-- 题目列表 -->
      <div class="question-list">
        <div v-for="(item, index) in questionList" :key="index" class="question-item">
          <el-form
            :ref="`form${index}`"
            :model="item"
            :rules="rules"
            label-width="0"
            inline
            :validate-on-rule-change="false">
            
            <!-- 题号 -->
            <el-form-item prop="question_seq" class="seq-item">
              <el-input
                v-model="item.question_seq"
                placeholder="题号"
                style="width: 50px;"
                disabled>
              </el-input>
            </el-form-item>
            
            <!-- 题目名称 -->
            <el-form-item prop="question_name" class="name-item">
              <el-input 
                v-model="item.question_name" 
                placeholder="请输入题目名称"
                style="width: 150px;">
              </el-input>
            </el-form-item>
            
            <!-- 分数 -->
            <el-form-item prop="question_score" class="score-item compact-number">
              <el-input-number
                class="no-controls"
                v-model="item.question_score"
                :min="0"
                :max="100"
                :step="1"
                @change="handleScoreChange(index)"
                placeholder="分数"
                style="width: 70px;">
              </el-input-number>
            </el-form-item>
            
            <!-- 订正分数 -->
            <el-form-item prop="question_score_fix" class="score-fix-item compact-number">
              <el-input-number
                class="no-controls"
                v-model="item.question_score_fix"
                :min="0"
                :max="100"
                :step="1"
                :disabled="item.question_score === 100"
                @change="handleScoreFixChange(index)"
                placeholder="订正分数"
                style="width: 70px;">
              </el-input-number>
            </el-form-item>
            
            <!-- 题目难度 -->
            <el-form-item prop="question_level" class="level-item">
              <el-select
                v-model="item.question_level"
                placeholder="题目难度"
                style="width: 120px">
                <el-option
                  v-for="level in questionLevels"
                  :key="level.value"
                  :label="level.label"
                  :value="level.value">
                  <span :style="getQuestionLevelStyle(level.value)">{{ level.label }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <!-- 错误类型（多选） -->
            <el-form-item class="errors-item">
              <el-select
                v-model="item.error_codes"
                multiple
                filterable
                placeholder="错误类型"
                style="width: 150px"
                :disabled="item.question_score === 100">
                <el-option
                  v-for="err in allErrors"
                  :key="err.error_code"
                  :label="err.error_name"
                  :value="err.error_code">
                  <el-tooltip :content="err.error_note" placement="right" effect="dark">
                    <span>
                      <el-tag :style="getErrorOutlineStyle(err.error_code)" style="margin-right: 8px;">
                        <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ err.error_name }}
                      </el-tag>
                    </span>
                  </el-tooltip>
                </el-option>
              </el-select>
            </el-form-item>
            
            <!-- 题目链接 -->
            <el-form-item prop="question_url" class="url-item">
              <el-input
                v-model="item.question_url"
                placeholder="请输入题目链接"
                style="width: 150px;">
              </el-input>
            </el-form-item>
            
            <!-- 备注 -->
            <el-form-item prop="note" class="note-item">
              <el-input
                v-model="item.note"
                placeholder="请输入备注"
                style="width: 150px;">
              </el-input>
            </el-form-item>
            
            <!-- 标签选择 -->
            <el-form-item class="tags-item">
              <el-tag
                v-for="tag in item.tags"
                :key="tag.tag_code"
                :style="{ backgroundColor: getTagColor(tag.tag_code), borderColor: getTagColor(tag.tag_code), color: 'white' }"
                closable
                @close="removeTag(index, tag)"
                style="margin-right: 5px; margin-bottom: 5px;">
                {{ tag.tag_name }}
              </el-tag>
              <el-button size="small" @click="showTagDialog(index)">选择标签</el-button>
            </el-form-item>
            
            <!-- 删除按钮 -->
            <el-button 
              type="danger" 
              icon="el-icon-delete" 
              circle
              size="mini"
              @click="handleDeleteRow(index)"
              v-if="questionList.length > 1">
            </el-button>
          </el-form>
          
          <!-- 错误提示 -->
          <div v-if="item.error" class="error-message">
            {{ item.error }}
          </div>
        </div>
      </div>
      
      <!-- 添加按钮 -->
      <div class="add-button">
        <el-button type="primary" icon="el-icon-plus" @click="handleAddRow">
          添加题目
        </el-button>
      </div>
      
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseButtonClick">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 标签选择弹窗 -->
    <el-dialog
      title="选择标签"
      :visible.sync="tagDialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="30%">
      <el-select
        v-model="selectedTagCodes"
        multiple
        filterable
        placeholder="请选择标签"
        style="width: 100%">
        <el-option
          v-for="tag in sortedTags"
          :key="tag.tag_code"
          :label="tag.tag_name"
          :value="tag.tag_code">
          <el-tag
            :style="{ backgroundColor: getTagColor(tag.tag_code), borderColor: getTagColor(tag.tag_code), color: 'white', height: '24px', lineHeight: '22px', padding: '0 8px', borderRadius: '4px' }"
            style="margin-right: 8px;">
            {{ tag.tag_name }}
          </el-tag>
        </el-option>
      </el-select>
      <div style="margin-top: 10px;">
        <el-button size="small" @click="showAddTagDialog">新增标签</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tagDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleTagSelect">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增标签弹窗 -->
    <el-dialog
      title="新增标签"
      :visible.sync="addTagDialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="30%">
      <el-form :model="newTag" :rules="tagRules" ref="tagForm" label-width="80px">
        <el-form-item label="标签名称" prop="tag_name">
          <el-input v-model="newTag.tag_name"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="newTag.note"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addTagDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddTag">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { QUESTION_LEVELS, getQuestionLevelStyle } from '@/constants/questionLevel'
import { getErrorOutlineStyle } from '@/constants/errorTypes'
import { getErrorTagInlineStyle } from '@/constants/errorTypes'

export default {
  name: 'BatchQuestionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gameCode: {
      type: String,
      default: ''
    }
  },
  data() {
    // URL格式验证
    const validateUrl = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      const urlPattern = /^https?:\/\/.+/i
      if (!urlPattern.test(value)) {
        callback(new Error('请输入有效的http/https URL'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: false,
      submitting: false,
      questionList: [],
      currentSeq: 1,
      internalGameCode: '',
      rules: {
        question_name: [
          { required: true, message: '请输入题目名称', trigger: 'blur' }
        ],
        question_score: [
          { required: true, message: '请输入分数', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '分数范围为0-100', trigger: 'blur' }
        ],
        question_score_fix: [
          { required: true, message: '请输入订正分数', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '分数范围为0-100', trigger: 'blur' }
        ],
        question_url: [
          { validator: validateUrl, trigger: 'blur' }
        ]
      },
      allTags: [],
      allErrors: [],
      selectedTagCodes: [],
      currentQuestionIndex: -1,
      tagDialogVisible: false,
      addTagDialogVisible: false,
      newTag: {
        tag_name: '',
        note: ''
      },
      tagRules: {
        tag_name: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ]
      },
      tagColors: [
        '#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399',
        '#9B59B6', '#2ECC71', '#3498DB', '#1ABC9C', '#E74C3C',
        '#34495E', '#16A085', '#27AE60', '#2980B9', '#8E44AD'
      ],
      questionLevels: QUESTION_LEVELS,
      showConfirmation: false
    }
  },
  computed: {
    sortedTags() {
      return [...this.allTags].sort((a, b) => a.tag_name.localeCompare(b.tag_name))
    }
  },
  watch: {
    visible(val) {
      console.log('BatchQuestionDialog visible changed to:', val)
      console.log('Current gameCode:', this.internalGameCode)
      this.dialogVisible = val
      if (val) {
        this.init()
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false)
      }
    },
    gameCode: {
      immediate: true,
      handler(val) {
        console.log('gameCode prop changed to:', val)
        if (val) {
          this.internalGameCode = val
        }
      }
    }
  },
  created() {
    // 获取标签数据
    this.fetchTags()
    this.fetchErrors()
  },
  methods: {
    getErrorOutlineStyle,
    // 新增：设置 game_code 的方法
    setGameCode(code) {
      console.log('Setting game code to:', code)
      this.internalGameCode = code
    },
    
    // 初始化
    async init() {
      console.log('Initializing BatchQuestionDialog with gameCode:', this.internalGameCode)
      this.questionList = []
      this.currentSeq = 1
      await this.fetchTags() // 获取标签列表
      this.handleAddRow()
    },
    
    // 生成题目编号
    generateQuestionCode() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let code = 'P_'
      for (let i = 0; i < 8; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return code
    },
    
    // 处理分数变化
    handleScoreChange(index) {
      const item = this.questionList[index]
      // 如果分数超过100，设置为100
      if (item.question_score > 100) {
        item.question_score = 100
      }
      // 如果分数为100，订正分数也设为100
      if (item.question_score === 100) {
        item.question_score_fix = 100
        item.error_codes = []
      }
    },
    
    // 处理订正分数变化
    handleScoreFixChange(index) {
      const item = this.questionList[index]
      // 如果订正分数超过100，设置为100
      if (item.question_score_fix > 100) {
        item.question_score_fix = 100
      }
    },
    
    // 添加新行
    handleAddRow() {
      this.questionList.push({
        question_code: this.generateQuestionCode(),
        question_seq: `T${this.currentSeq}`,
        question_name: '',
        question_score: '',
        question_score_fix: '',
        question_level: '',
        question_url: '',
        note: '',
        error: '',
        game_code: this.internalGameCode,
        tags: [] // 初始化标签数组
      })
      this.currentSeq++
    },
    
    // 删除行
    handleDeleteRow(index) {
      this.questionList.splice(index, 1)
    },
    
    // 验证所有表单
    async validateForms() {
      const validateResults = await Promise.all(
        this.questionList.map((_, index) => {
          const form = this.$refs[`form${index}`][0]
          return form.validate().catch(() => false)
        })
      )
      return validateResults.every(valid => valid === true)
    },
    
    // 提交数据
    async handleSubmit() {
      try {
        console.log('Starting form validation...')
        console.log('Current gameCode:', this.internalGameCode)
        console.log('Current form data:', this.questionList)
        
        // 验证所有表单
        const valid = await this.validateForms()
        if (!valid) {
          this.$message.error('请检查表单数据')
          return
        }
        
        // 检查是否有题目
        if (this.questionList.length === 0) {
          this.$message.error('请至少添加一个题目')
          return
        }
        
        // 检查 game_code
        if (!this.internalGameCode) {
          this.$message.error('赛事编号不能为空')
          return
        }
        
        this.submitting = true
        
        // 准备提交数据
        const submitData = {
          game_code: this.internalGameCode,
          questions: this.questionList.map(item => ({
            question_seq: item.question_seq,
            question_name: item.question_name.trim(),
            question_score: Number(item.question_score),
            question_score_fix: Number(item.question_score_fix),
            question_level: item.question_level || '',
            question_url: (item.question_url || '').trim(),
            note: (item.note || '').trim(),
            tags: (item.tags || []).map(tag => tag.tag_code),
            error_codes: (item.error_codes || [])
          }))
        }
        
        console.log('Submitting data:', submitData)
        
        // 发送请求
        const res = await request({
          url: '/api/game/questions/batch',
          method: 'post',
          data: submitData
        })
        
        if (res.code === 200) {
          this.$message.success('批量添加成功')
          this.$emit('success')
          this.closeDialog()
        } else {
          throw new Error(res.message || '添加失败')
        }
      } catch (error) {
        console.error('Failed to submit questions:', error)
        this.$message.error(error.message || '添加失败')
      } finally {
        this.submitting = false
      }
    },
    
    // 重置表单
    resetForm() {
      this.questionList = []
      this.currentSeq = 1
      this.init()
    },
    
    // 取消
    async handleCancel() {
      const hasData = this.questionList.some(item => 
        item.question_name || item.question_url || item.note)
      
      if (hasData) {
        try {
          await this.$confirm('有未保存的题目数据，确认要取消吗？', '提示', {
            type: 'warning'
          })
          this.handleClose()
        } catch {
          // 用户取消关闭
        }
      } else {
        this.handleClose()
      }
    },
    
    // 关闭对话框
    handleClose() {
      this.questionList = []
      this.currentSeq = 1
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    
    async fetchTags() {
      try {
        const res = await request({
          url: '/api/tags',
          method: 'get'
        })
        if (res.code === 200) {
          this.allTags = res.data
        }
      } catch (error) {
        console.error('Failed to fetch tags:', error)
        this.$message.error('获取标签列表失败')
      }
    },
    async fetchErrors() {
      try {
        const res = await request({ url: '/api/error-codes', method: 'get' })
        if (res.code === 200) {
          this.allErrors = res.data || []
        }
      } catch (e) {
        // ignore
      }
    },
    
    getTagColor(tagCode) {
      // 使用与其他组件相同的颜色映射
      const colors = {
        'tag-color-1': '#409EFF',  // Element UI 主蓝色
        'tag-color-2': '#67C23A',  // Element UI 成功绿色
        'tag-color-3': '#E6A23C',  // Element UI 警告黄色
        'tag-color-4': '#F56C6C',  // Element UI 危险红色
        'tag-color-5': '#8E44AD',  // 深紫色
        'tag-color-6': '#16A085',  // 深青色
        'tag-color-7': '#D35400',  // 深橙色
        'tag-color-8': '#2980B9',  // 深蓝色
        'tag-color-9': '#27AE60',  // 深绿色
        'tag-color-10': '#C0392B'  // 深红色
      }
      
      // 使用与其他组件相同的索引生成方式
      const colorClasses = [
        'tag-color-1', 'tag-color-2', 'tag-color-3', 'tag-color-4', 'tag-color-5',
        'tag-color-6', 'tag-color-7', 'tag-color-8', 'tag-color-9', 'tag-color-10'
      ]
      const index = parseInt(tagCode.split('_')[1], 36) % colorClasses.length
      return colors[colorClasses[index]]
    },
    
    hashCode(str) {
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(i)
        hash = hash & hash
      }
      return hash
    },
    
    showTagDialog(index) {
      this.currentQuestionIndex = index
      this.selectedTagCodes = this.questionList[index].tags?.map(t => t.tag_code) || []
      this.tagDialogVisible = true
    },
    
    handleTagSelect() {
      const selectedTags = this.selectedTagCodes.map(code => {
        return this.allTags.find(tag => tag.tag_code === code)
      })
      this.$set(this.questionList[this.currentQuestionIndex], 'tags', selectedTags)
      this.tagDialogVisible = false
    },
    
    removeTag(questionIndex, tag) {
      const tags = this.questionList[questionIndex].tags
      const index = tags.findIndex(t => t.tag_code === tag.tag_code)
      if (index > -1) {
        tags.splice(index, 1)
      }
    },
    
    showAddTagDialog() {
      this.addTagDialogVisible = true
    },
    
    async handleAddTag() {
      this.$refs.tagForm.validate(async valid => {
        if (valid) {
          try {
            const res = await request({
              url: '/api/tags',
              method: 'post',
              data: this.newTag
            })
            if (res.code === 200) {
              this.$message.success('添加标签成功')
              await this.fetchTags()
              this.addTagDialogVisible = false
              this.$refs.tagForm.resetFields()
            }
          } catch (error) {
            this.$message.error('添加标签失败')
          }
        }
      })
    },
    
    // 新方法：处理关闭按钮点击
    handleCloseButtonClick() {
      this.handleCloseRequest();
    },
    
    // 新方法：处理关闭请求
    handleCloseRequest() {
      const hasData = this.questionList.some(item => 
        item.question_name || 
        item.question_score || 
        item.question_score_fix || 
        item.question_level || 
        item.question_url || 
        item.note ||
        (item.tags && item.tags.length > 0));
      
      if (hasData && !this.showConfirmation) {
        // 显示自定义确认对话框
        this.showConfirmation = true;
      } else if (!hasData) {
        // 没有修改，直接关闭
        this.closeDialog();
      }
    },
    
    // 新方法：取消关闭
    cancelClose() {
      this.showConfirmation = false;
    },
    
    // 新方法：确认关闭
    confirmClose() {
      this.showConfirmation = false;
      this.closeDialog();
    },
    
    // 新方法：关闭对话框
    closeDialog() {
      this.questionList = [];
      this.currentSeq = 1;
      this.dialogVisible = false;
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    
    // 处理对话框关闭事件
    handleDialogClose() {
      this.handleCloseRequest();
    },
    
    // 原来的handleBeforeClose方法可以保留作为兼容，但内部改为使用新的关闭逻辑
    async handleBeforeClose(done) {
      this.handleCloseRequest();
    },
    
    getQuestionLevelStyle
    ,
    getErrorTagInlineStyle
  }
}
</script>

<style lang="scss" scoped>
.batch-question-dialog {
  .question-list {
    max-height: 60vh;
    overflow-y: auto;
    padding: 0 20px;
  }
  
  .question-item {
    margin-bottom: 15px;
    padding: 10px;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    
    &:hover {
      background-color: #f5f7fa;
    }
    
    .el-form {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 10px;
      
      .seq-item {
        width: 60px;
      }
      
      .name-item {
        width: 150px;
      }
      
      .score-item,
      .score-fix-item {
        width: 50px;
        
        ::v-deep .el-input {
          width: 50px;
          
          .el-input__inner {
            padding-right: 4px;
            text-align: left;
            
            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
        }
      }

      .compact-number {
        ::v-deep .el-input-number__decrease,
        ::v-deep .el-input-number__increase {
          display: none;
        }
      }
      
      .url-item { width: auto; }
      .note-item { width: auto; }
      
      .level-item {
        width: auto; /* 让容器自适应 */
        margin-right: 10px;
        z-index: 1; // 提高下拉框的层级
      }

      .errors-item {
        width: 180px;
      }
      
      .tags-item {
        flex: 1;
        margin-bottom: 10px;
        
        .el-tag {
          margin-right: 5px;
          margin-bottom: 5px;
          border-radius: 4px;
          padding: 0 8px;
          height: 24px;
          line-height: 22px;
        }
      }
    }
    
    .error-message {
      color: #F56C6C;
      font-size: 12px;
      margin-top: 5px;
      padding-left: 10px;
    }
  }
}

.add-button {
  margin-top: 20px;
  text-align: center;
}

::v-deep .el-form-item {
  margin-bottom: 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.tags-item {
  flex: 1;
  margin-bottom: 10px;
}

.level-item {
  width: 120px;
  margin-right: 10px;
}

/* 隐藏数字输入的加减按钮，保持一行更紧凑 */
::v-deep .no-controls {
  .el-input-number__decrease,
  .el-input-number__increase { display: none; }
  .el-input__inner { padding-left: 10px !important; padding-right: 8px !important; }
}

/* 垂直居中对话框样式 */
/* 由于 custom-class 直接加在 .el-dialog 上，这里直接命中该类本身 */
::v-deep .batch-question-dialog-centered {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  position: fixed !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
}

/* 自定义确认对话框样式 */
.confirmation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirmation-dialog {
  background-color: white;
  border-radius: 4px;
  padding: 20px;
  width: 300px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.confirmation-content {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.confirmation-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style> 